module.exports = __webpack_public_path__ + "media/images/font/Gustavo-MediumItalic-616e241cb388f955dc8b1261cf52e45b.woff2";